var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconSatellite3 = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.884 6.018a2.344 2.344 0 0 0 1.657 4l2.344-2.343a2.344 2.344 0 0 0-4-1.657m0 0-.994-.995m6.216 4.079a3.29 3.29 0 0 1-1.993 1.996m3.98-2.215a5.16 5.16 0 0 1-4.205 4.205m6.143-4.673a7.03 7.03 0 0 1-6.718 6.616M9.86 2.574l1.327-1.326s.662-.662 1.325 0l1.326 1.326s.663.663 0 1.326l-1.325 1.326s-.664.663-1.326 0L9.86 3.9s-.662-.662 0-1.326m-8.617 8.747 1.325-1.325s.663-.663 1.326 0l1.326 1.325s.662.663 0 1.326l-1.326 1.326s-.662.663-1.326 0l-1.325-1.326s-.663-.662 0-1.326"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.884 6.018a2.344 2.344 0 0 0 1.657 4l2.344-2.343a2.344 2.344 0 0 0-4-1.657m0 0-.994-.995m6.216 4.079a3.29 3.29 0 0 1-1.993 1.996m3.98-2.215a5.16 5.16 0 0 1-4.205 4.205m6.143-4.673a7.03 7.03 0 0 1-6.718 6.616M9.86 2.574l1.327-1.326s.662-.662 1.325 0l1.326 1.326s.663.663 0 1.326l-1.325 1.326s-.664.663-1.326 0L9.86 3.9s-.662-.662 0-1.326m-8.617 8.747 1.325-1.325s.663-.663 1.326 0l1.326 1.325s.662.663 0 1.326l-1.326 1.326s-.662.663-1.326 0l-1.325-1.326s-.663-.662 0-1.326"
  }));
});
export default SvgIconSatellite3;
export const raw = __webpack_public_path__ + "static/media/IconSatellite3.d31d93abbb27ac4d665f4ebc9e72d643.svg";